var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiBoxFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1413_9745)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.174 5.20276C27.4176 5.3 27.6265 5.468 27.7738 5.6851C27.921 5.90221 27.9998 6.15845 28 6.42076V21.5793C27.9998 21.8416 27.921 22.0978 27.7738 22.3149C27.6265 22.532 27.4176 22.7 27.174 22.7973L14.4865 27.8723C14.1736 27.9974 13.8246 27.9974 13.5118 27.8723L0.82425 22.7973C0.580946 22.6998 0.372409 22.5316 0.225506 22.3146C0.0786023 22.0975 6.10049e-05 21.8414 0 21.5793L0 6.42076C6.10049e-05 6.15865 0.0786023 5.90255 0.225506 5.68547C0.372409 5.46839 0.580946 5.30027 0.82425 5.20276L13.0252 0.322014L13.0323 0.320264L13.5118 0.127764C13.8251 0.00217116 14.1749 0.00217116 14.4883 0.127764L14.9678 0.320264L14.9748 0.322014L27.174 5.20276ZM24.7695 6.12501L14 10.4335L3.2305 6.12501L1.75 6.71826V7.41826L13.125 11.9683V25.8318L14 26.1818L14.875 25.8318V11.97L26.25 7.42001V6.72001L24.7695 6.12501Z",
    fill: "#113870"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1413_9745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiBoxFill);
export default __webpack_public_path__ + "static/media/bi_box-fill.270fa02e4227c8edc9edbe4e79e76be9.svg";
export { ForwardRef as ReactComponent };